import './address-search.scss'
import { createAreaPopoverPlugin } from './plugins/popover.js'
import { isFunction } from 'lodash'
export default {
  name: 'KyeAddressSearch',
  reportName: 'kye-addressSearch',
  props: {
    value: {
      type: String,
      default: ''
    },
    filterSearch: Function,
    region: String,
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入详细地址'
    },
    autocompleteAttrs: {
      type: Object,
      default: () => ({})
    },
    showFullAddress: {
      type: Boolean,
      default: false
    },
    beforeSearchSelect: Function
  },
  data() {
    const { validate, showInputError, clearValidate, setShowInputErrorStatus } = createAreaPopoverPlugin(this)
    return {
      newValue: '',
      isFocus: false,
      selectItem: {},
      validate,
      showInputError,
      clearValidate,
      setShowInputErrorStatus,
      isAllowCompareTitle: true
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.newValue = val
        this.selectItem.title = val
      }
    }
  },
  computed: {
    showClear() {
      return this.newValue && this.clearable && this.isFocus
    }
  },
  render(h) {
    const { $props } = this
    const { autocompleteAttrs, placeholder } = $props
    const searchInputProps = {
      value: this.newValue,
      placeholder: placeholder,
      popperClass: '',
      valueKey: 'fullAddress',
      triggerOnFocus: false,
      fetchSuggestions: this.searchFetch,
      ...autocompleteAttrs
    }

    const searchItem = (scope) => {
      return <div class="kye-address-search-item">
        <span class="kye-address-search-item-title" domPropsInnerHTML={scope.item.$title} title={scope.item.title}></span>
        <span class="kye-address-search-item-address" title={scope.item.fullAddress}>{scope.item.fullAddress}</span>
      </div>
    }
    const searchClear = () => {
      return <i slot="suffix"
        class="el-input__icon el-icon-circle-close address-search-clear"
        on-mousedown={(e) => e.preventDefault()}
        onClick={ this.clear }>
      </i>
    }
    const contentClear = this.showClear && searchClear()
    const searchBind = {
      props: { ...searchInputProps },
      ref: 'addressSearchInput',
      on: {
        select: this.searchSelect,
        focus: this.searchFocus,
        blur: this.searchBlur,
        input: this.searchInput
      },
      nativeOn: {
        mouseenter: this.mouseenter,
        mouseleave: this.mouseleave,
        change: this.searchChange
      },
      class: {
        'kye-address-search-input': true,
        'kye-address-error': this.showInputError
      },
      scopedSlots: {
        default: (scope) => { return searchItem(scope) },
      },
    }
    const searchAutoComplete = () => {
      return <el-autocomplete
        {...searchBind}
      >
        {contentClear}
      </el-autocomplete>
    }
    const addressSearch = searchAutoComplete()
    return addressSearch
  },
  methods: {
    // 远程下拉搜索
    async searchFetch(val, cb) {
      try {
        let data = await this.$http('map.search.suggest.suggestPlus', {keyword: val, region: this.region}, {
          appkey: '55844'
        })
        if (data && data.resultList && data.resultList.length > 0) {
          if (this.filterSearch && typeof this.filterSearch === 'function') {
            data.resultList = this.filterSearch(data.resultList)
          }
          const escapedVal = escapeRegExp(val)
          const reg = new RegExp(escapedVal, 'gi')
          console.log('res--', reg)
          data.resultList.map(item => {
            item.$title = `${item.title.replace(reg, value => `<span style="color: var(--g-color-primary);">${value}</span>`)}`
          })
          cb(data.resultList)
        } else {
          const noData = []
          cb(noData)
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    async searchSelect (item) {
      const callBack = this.$props.beforeSearchSelect
      const selected = (val) => {
        if (val) {
          if (this.showFullAddress) {
            this.newValue = item.fullAddress
          } else {
            this.newValue = item.title
          }
          this.selectItem = item
          this.$emit('select', this.selectItem)
          this.$emit('input', this.newValue)
        }
        this.$refs.addressSearchInput.$refs.input.setCurrentValue(this.newValue)
      }
      if (!isFunction(callBack)) {
        this.isAllowCompareTitle = true
        selected(true)
      } else {
        this.isAllowCompareTitle = false
        const result = callBack(item)
        if (result && result.then) {
          result.then(val => {
            selected(val)
          })
        } else {
          selected(result)
        }
      }
    },
    searchFocus() {
      this.isFocus = true
      this.$emit('focus')
      this.isAllowCompareTitle = true
    },
    searchInput(val) {
      this.$emit('searchInput', val)
    },
    searchBlur() {
      this.isFocus = false
      this.$emit('blur')
      const currentValue = this.$refs.addressSearchInput.$refs.input.currentValue
      if (!this.$refs.addressSearchInput.$refs.suggestions.showPopper && !currentValue) {
        if (currentValue !== this.selectItem.title) {
          this.selectItem = {}
          this.selectItem.title = currentValue
          this.newValue = currentValue
          this.$emit('select', this.selectItem)
          this.$emit('input', this.newValue)
        }
      }
    },
    mouseenter() {
      this.isFocus = true
      this.$emit('mouseenter')
    },
    mouseleave() {
      this.isFocus = false
      this.$emit('mouseleave')
    },
    clear() {
      this.newValue = ''
      this.selectItem = {}
      this.$emit('clear')
      this.$emit('change', '')
      this.$emit('input', '')
    },
    searchChange (e) {
      this.$emit('change', e.target ? e.target.value : e)
    },
    suggestionsVisible (val) {
      const allow = this.isAllowCompareTitle
      if (!val && allow) {
        this.$nextTick(() => {
          const currentValue = this.$refs.addressSearchInput.$refs.input.currentValue
          if (currentValue !== this.selectItem.title) {
            this.selectItem = {}
            this.selectItem.title = currentValue
            this.newValue = currentValue
            this.$emit('select', this.selectItem)
            this.$emit('input', this.newValue)
          }
        })
      }
    }
  },
  mounted () {
    this.$refs.addressSearchInput.$refs.suggestions.$on('visible', this.suggestionsVisible)
  },
  beforeDestroy () {
    this.$refs.addressSearchInput.$refs.suggestions.$off('visible', this.suggestionsVisible)
  }
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}





// WEBPACK FOOTER //
// ./src/public/components/kye-address-search/address-search.js